import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { Fill } from 'shared/components/styled';
import { useUser, signOut } from 'shared/auth';
import { useUserActions } from 'shared/auth/hooks/useUserActions';
import DocumentTitle from 'shared/components/DocumentTitle';
import AppHeader from 'shared/components/AppHeader';

export default function PortalRoot({ title, nav, hideHeader, children }) {
  const user = useUser();
  const { push } = useHistory();
  const { isBBUser, isCNUser } = useUserActions();
  const effectiveUser = user && user.effectiveUser;

  const handleLogout = useCallback(() => {
    signOut();
    // CN users have no Cognito login; send them back to the widget entry point.
    if (isCNUser) window.location.assign('/cn-widget');
  }, [isCNUser]);

  const handleAccount = useCallback(() => {
    push('/account/my-account');
  }, [push]);

  return (
    <>
      <DocumentTitle template={title} />
      {!hideHeader && (
        <AppHeader nav={nav} hideAccountMenu={!effectiveUser || isBBUser} />
      )}
      <Fill>{children}</Fill>
    </>
  );
}
